// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Manual X-Grid HTML structure for displaying deployments */

.sourceDetails_settings {
  flex-grow: 1;
  min-height: 0;
  display: flex;
}


.sourceDetails_settings .MuiDataGrid-main {
  gap: 15px;
  padding: 0 10px;
  display: flex;
  overflow: hidden auto;
  flex-direction: column;
} 

@supports (-moz-appearance: none) {  
  .sourceDetails_settings .MuiDataGrid-main {
    margin: 0 0px;
    padding: 0 0px;
  }
}


/* source container */
.sourceDetails_settings .container {
  width: 95%;
  margin: 0 auto;
  padding: 5px 0px; 
  border-radius: var(--radius-medium);
}

@media(max-width: 366px) {
  .sourceDetails__settings .container,
  .sourceDetails__settings hr {
    width: 100% !important;
  }
}

.container.open {
  /* background-color: #f6f6f6; */
  background-color: #f8f8f8;
  border: 2px solid #e0e0e0;
  margin-bottom: 18px;
}
.container.closed { 
  margin-bottom: 2px;
  padding: 0px 0px 0px 24px
}
.container.closed .container__content {
  display: none;
}

.container.open_selected {
  /* background-color: #f6e4f6; */
  background-color: #f6f6f6;
  /* border: 5px solid #e5d3e5;  */
  margin-bottom: 18px;
}
.container.closed_selected { 
  margin-bottom: 18px;
}
.container.closed_selected .container__content {
  display: none;
}

.container.open_selected .container__title{
  color:  #a91c84 !important;
}
.container.closed_selected .container__title{
  color: #a91c84 !important;
}

/* Scenario title */
.container__header {
  gap: 5px;
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: 1fr auto;
  justify-content: space-between;
}

.container__title {
  font-size: 15px;
  transition: 0.25s;

  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;

  gap: 5px;
  flex-grow: 1;
  display: flex;
  align-items: center;
}

.container__title:hover > h3,
.container.open .container__title > h3 {
  text-decoration: underline;
}

/* Scenario options */
.container__options {
  gap: 15px;
  display: flex;
  -webkit-user-select: none;
          user-select: none;
  align-items: center;
}

.container__options .separation {
  height: 100%;
  border: 1px solid var(--separation-color);
  background-color: var(--separation-color);
}

/* Scenario actions */
.container__actions {
  gap: 5px;
  display: flex;
}
.container__actions .button.icon {
  height: 32px;
  padding: 0 5px !important;
  background-color: transparent;
}


/* Scenario content */
.container__content {
  gap: 10px;
  /* padding: 5px 0px; */
  flex-direction: column;
}
.container__content > * {
  font-size: 14px;
  /* padding: 6px 12px; */
}

.container__sharingOptions > span:first-child {
  font-weight: 600;
  color: rgb(var(--accent-color));
}

.container__locations > span:first-child {
  font-weight: 600;
  color: rgb(var(--accent-color));
}


/* Modules + Conditions Table */
.container__table .MuiTableRow-root {
  display: grid;
  /* grid-template-columns: 1fr 3fr; */
}

.container__table .MuiTableCell-root {
  display: flex;
  min-height: 52px;
  /*align-items: left;*/
  
  padding: 12px;
  font-size: 15px;
  font-family: inherit;
  border-bottom: 2px solid var(--separation-color-light);
}

.container__table .MuiTableRow-root > .MuiTableCell-root:not(:first-child) {
  /* Add left border for all columns (except the first one) */
  border-left: 2px solid var(--separation-color-light);
}

.container__table .MuiTableBody-root > .MuiTableRow-root:last-child > .MuiTableCell-root {
  /* Remove last row bottom border */
  border-bottom: none;
}


.top { 
  display: inline-block;
  vertical-align:top;
  width: 100%;
}
.bottom {
  display: inline-block;
  vertical-align:bottom;
  width: 100%;
}
/* .bottom:before{
  content: '';
  display: inline-block;
  height: 100px;
} */


/* .container__table__title {
  font-size: 16px;
  font-weight: 600;
  color: rgb(var(--accent-color));
} */


/* Conditions formatting */
/* .container__condition .error, .container__condition .error * {
  color: #f22 !important;
  font-weight: normal !important;
} */

/* .container__condition .and-or {
  font-weight: 600;
  color: rgb(var(--accent-color));
}
.container__condition .operator {
  font-weight: 600;
} */

/* New line for each 'AND' or 'OR' condition */
/* .container__condition > span:not(.error) {
  white-space: pre-line;
} */
/* .container__condition > span:not(.error) .and-or::after {
  content: '\\000A';
} */
`, "",{"version":3,"sources":["webpack://./src/Components/Dashboard/Sources/Details/sourceDetails.css"],"names":[],"mappings":"AAAA,4DAA4D;;AAE5D;EACE,YAAY;EACZ,aAAa;EACb,aAAa;AACf;;;AAGA;EACE,SAAS;EACT,eAAe;EACf,aAAa;EACb,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE;IACE,aAAa;IACb,cAAc;EAChB;AACF;;;AAGA,qBAAqB;AACrB;EACE,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE;;IAEE,sBAAsB;EACxB;AACF;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB;AACF;AACA;EACE,aAAa;AACf;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,gCAAgC;EAChC,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;;AAEA;EACE,0BAA0B;AAC5B;AACA;EACE,yBAAyB;AAC3B;;AAEA,mBAAmB;AACnB;EACE,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,iBAAiB;;EAEjB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;;EAEjB,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA,qBAAqB;AACrB;EACE,SAAS;EACT,aAAa;EACb,yBAAiB;UAAjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,yCAAyC;EACzC,yCAAyC;AAC3C;;AAEA,qBAAqB;AACrB;EACE,QAAQ;EACR,aAAa;AACf;AACA;EACE,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;AAC/B;;;AAGA,qBAAqB;AACrB;EACE,SAAS;EACT,sBAAsB;EACtB,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;AACjC;;;AAGA,+BAA+B;AAC/B;EACE,aAAa;EACb,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,qBAAqB;;EAErB,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,sDAAsD;AACxD;;AAEA;EACE,2DAA2D;EAC3D,oDAAoD;AACtD;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;AACrB;;;AAGA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,WAAW;AACb;AACA;;;;GAIG;;;AAGH;;;;GAIG;;;AAGH,0BAA0B;AAC1B;;;GAGG;;AAEH;;;;;;GAMG;;AAEH,8CAA8C;AAC9C;;GAEG;AACH;;GAEG","sourcesContent":["/* Manual X-Grid HTML structure for displaying deployments */\r\n\r\n.sourceDetails_settings {\r\n  flex-grow: 1;\r\n  min-height: 0;\r\n  display: flex;\r\n}\r\n\r\n\r\n.sourceDetails_settings .MuiDataGrid-main {\r\n  gap: 15px;\r\n  padding: 0 10px;\r\n  display: flex;\r\n  overflow: hidden auto;\r\n  flex-direction: column;\r\n} \r\n\r\n@supports (-moz-appearance: none) {  \r\n  .sourceDetails_settings .MuiDataGrid-main {\r\n    margin: 0 0px;\r\n    padding: 0 0px;\r\n  }\r\n}\r\n\r\n\r\n/* source container */\r\n.sourceDetails_settings .container {\r\n  width: 95%;\r\n  margin: 0 auto;\r\n  padding: 5px 0px; \r\n  border-radius: var(--radius-medium);\r\n}\r\n\r\n@media(max-width: 366px) {\r\n  .sourceDetails__settings .container,\r\n  .sourceDetails__settings hr {\r\n    width: 100% !important;\r\n  }\r\n}\r\n\r\n.container.open {\r\n  /* background-color: #f6f6f6; */\r\n  background-color: #f8f8f8;\r\n  border: 2px solid #e0e0e0;\r\n  margin-bottom: 18px;\r\n}\r\n.container.closed { \r\n  margin-bottom: 2px;\r\n  padding: 0px 0px 0px 24px\r\n}\r\n.container.closed .container__content {\r\n  display: none;\r\n}\r\n\r\n.container.open_selected {\r\n  /* background-color: #f6e4f6; */\r\n  background-color: #f6f6f6;\r\n  /* border: 5px solid #e5d3e5;  */\r\n  margin-bottom: 18px;\r\n}\r\n.container.closed_selected { \r\n  margin-bottom: 18px;\r\n}\r\n.container.closed_selected .container__content {\r\n  display: none;\r\n}\r\n\r\n.container.open_selected .container__title{\r\n  color:  #a91c84 !important;\r\n}\r\n.container.closed_selected .container__title{\r\n  color: #a91c84 !important;\r\n}\r\n\r\n/* Scenario title */\r\n.container__header {\r\n  gap: 5px;\r\n  display: grid;\r\n  grid-auto-flow: column;\r\n  grid-auto-columns: 1fr auto;\r\n  justify-content: space-between;\r\n}\r\n\r\n.container__title {\r\n  font-size: 15px;\r\n  transition: 0.25s;\r\n\r\n  cursor: pointer;\r\n  user-select: none;\r\n\r\n  gap: 5px;\r\n  flex-grow: 1;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.container__title:hover > h3,\r\n.container.open .container__title > h3 {\r\n  text-decoration: underline;\r\n}\r\n\r\n/* Scenario options */\r\n.container__options {\r\n  gap: 15px;\r\n  display: flex;\r\n  user-select: none;\r\n  align-items: center;\r\n}\r\n\r\n.container__options .separation {\r\n  height: 100%;\r\n  border: 1px solid var(--separation-color);\r\n  background-color: var(--separation-color);\r\n}\r\n\r\n/* Scenario actions */\r\n.container__actions {\r\n  gap: 5px;\r\n  display: flex;\r\n}\r\n.container__actions .button.icon {\r\n  height: 32px;\r\n  padding: 0 5px !important;\r\n  background-color: transparent;\r\n}\r\n\r\n\r\n/* Scenario content */\r\n.container__content {\r\n  gap: 10px;\r\n  /* padding: 5px 0px; */\r\n  flex-direction: column;\r\n}\r\n.container__content > * {\r\n  font-size: 14px;\r\n  /* padding: 6px 12px; */\r\n}\r\n\r\n.container__sharingOptions > span:first-child {\r\n  font-weight: 600;\r\n  color: rgb(var(--accent-color));\r\n}\r\n\r\n.container__locations > span:first-child {\r\n  font-weight: 600;\r\n  color: rgb(var(--accent-color));\r\n}\r\n\r\n\r\n/* Modules + Conditions Table */\r\n.container__table .MuiTableRow-root {\r\n  display: grid;\r\n  /* grid-template-columns: 1fr 3fr; */\r\n}\r\n\r\n.container__table .MuiTableCell-root {\r\n  display: flex;\r\n  min-height: 52px;\r\n  /*align-items: left;*/\r\n  \r\n  padding: 12px;\r\n  font-size: 15px;\r\n  font-family: inherit;\r\n  border-bottom: 2px solid var(--separation-color-light);\r\n}\r\n\r\n.container__table .MuiTableRow-root > .MuiTableCell-root:not(:first-child) {\r\n  /* Add left border for all columns (except the first one) */\r\n  border-left: 2px solid var(--separation-color-light);\r\n}\r\n\r\n.container__table .MuiTableBody-root > .MuiTableRow-root:last-child > .MuiTableCell-root {\r\n  /* Remove last row bottom border */\r\n  border-bottom: none;\r\n}\r\n\r\n\r\n.top { \r\n  display: inline-block;\r\n  vertical-align:top;\r\n  width: 100%;\r\n}\r\n.bottom {\r\n  display: inline-block;\r\n  vertical-align:bottom;\r\n  width: 100%;\r\n}\r\n/* .bottom:before{\r\n  content: '';\r\n  display: inline-block;\r\n  height: 100px;\r\n} */\r\n\r\n\r\n/* .container__table__title {\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  color: rgb(var(--accent-color));\r\n} */\r\n\r\n\r\n/* Conditions formatting */\r\n/* .container__condition .error, .container__condition .error * {\r\n  color: #f22 !important;\r\n  font-weight: normal !important;\r\n} */\r\n\r\n/* .container__condition .and-or {\r\n  font-weight: 600;\r\n  color: rgb(var(--accent-color));\r\n}\r\n.container__condition .operator {\r\n  font-weight: 600;\r\n} */\r\n\r\n/* New line for each 'AND' or 'OR' condition */\r\n/* .container__condition > span:not(.error) {\r\n  white-space: pre-line;\r\n} */\r\n/* .container__condition > span:not(.error) .and-or::after {\r\n  content: '\\000A';\r\n} */\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
